export const isEqualString = (status1?: string, status2?: string): boolean =>
  !!status2 && !!status1?.toLowerCase()?.includes(status2?.toLowerCase?.());

export const sliceFiveChar = (str: string): string => (str.length > 5 ? str.slice(0, 5) : str);

export const validSignedUrl = (str: string) => {
  const subStringToCheck = 'https://ibe-dev-attach.s3.amazonaws.com/?AWSAccessKeyId';
  return str?.startsWith(subStringToCheck) ? '' : str;
};

export const removeSpecialCharacters = (str: string) =>
  str ? str.replace(/[^a-zA-Z0-9]/g, '') : '';
